import black_guitar_mask_png from "url:/src/img/black-guitar-mask.png";
import black_guitar_png from "url:/src/img/black-guitar.png";
import black_logo_svg from "url:/src/img/black-logo.svg";
import bullet_png from "url:/src/img/bullet.png";
import click_picto_svg from "url:/src/img/click-picto.svg";
import darkmoon_png from "url:/src/img/darkmoon.png";
import flash_png from "url:/src/img/flash.png";
import gradient_png from "url:/src/img/gradient.png";
import guitar_stand_png from "url:/src/img/guitar-stand.png";
import ie11_png from "url:/src/img/ie11.png";
import move_picto_svg from "url:/src/img/move-picto.svg";
import safari_png from "url:/src/img/safari.png";
import score_svg from "url:/src/img/score.svg";
import sound_picto_svg from "url:/src/img/sound-picto.svg";
import star_png from "url:/src/img/star.png";
import stars_texture_png from "url:/src/img/stars-texture.png";
import vandamme_loose_png from "url:/src/img/vandamme_loose.png";
import vandamme_win_png from "url:/src/img/vandamme_win.png";
import white_guitar_mask_png from "url:/src/img/white-guitar-mask.png";
import white_guitar_png from "url:/src/img/white-guitar.png";
import white_logo_svg from "url:/src/img/white-logo.svg";
import windows_jpg from "url:/src/img/windows.jpg";
import xd_png from "url:/src/img/xd.png";
import acdc_mp3 from "url:/src/sounds/acdc.mp3";
import boss_death_mp3 from "url:/src/sounds/boss-death.mp3";
import coin_wav from "url:/src/sounds/coin.wav";
import damage_mp3 from "url:/src/sounds/damage.mp3";
import player_death_mp3 from "url:/src/sounds/player-death.mp3";
import rocket_mp3 from "url:/src/sounds/rocket.mp3";
import shoot_mp3 from "url:/src/sounds/shoot.mp3";

const imgsrcs = [];
imgsrcs.push(black_guitar_mask_png);
imgsrcs.push(black_guitar_png);
imgsrcs.push(black_logo_svg);
imgsrcs.push(bullet_png);
imgsrcs.push(click_picto_svg);
imgsrcs.push(darkmoon_png);
imgsrcs.push(flash_png);
imgsrcs.push(gradient_png);
imgsrcs.push(guitar_stand_png);
imgsrcs.push(ie11_png);
imgsrcs.push(move_picto_svg);
imgsrcs.push(safari_png);
imgsrcs.push(score_svg);
imgsrcs.push(sound_picto_svg);
imgsrcs.push(star_png);
imgsrcs.push(stars_texture_png);
imgsrcs.push(vandamme_loose_png);
imgsrcs.push(vandamme_win_png);
imgsrcs.push(white_guitar_mask_png);
imgsrcs.push(white_guitar_png);
imgsrcs.push(white_logo_svg);
imgsrcs.push(windows_jpg);
imgsrcs.push(xd_png);

const audiosrcs = [];
audiosrcs.push(acdc_mp3);
audiosrcs.push(boss_death_mp3);
audiosrcs.push(coin_wav);
audiosrcs.push(damage_mp3);
audiosrcs.push(player_death_mp3);
audiosrcs.push(rocket_mp3);
audiosrcs.push(shoot_mp3);

export {audiosrcs, imgsrcs};